/*
 * SK — Accueil (mobile) : bouton « Swipe » animé pour le carrousel d'avis.
 * Remplace les points : un bouton pilule sous .sk-reviews__carousel qui, au tap,
 * fait défiler à l'avis suivant (et reboucle au début à la fin). Visible
 * uniquement sur mobile (via sk-home-mobile.css). Le geste de swipe reste dispo.
 */
(function () {
  function currentIndex(carousel, cards) {
    var cLeft = carousel.getBoundingClientRect().left;
    var best = 0, bestDist = Infinity;
    cards.forEach(function (card, i) {
      var d = Math.abs(card.getBoundingClientRect().left - cLeft);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function initSwipeButton() {
    var carousels = document.querySelectorAll('.sk-reviews__carousel');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      if (carousel.dataset.skSwipe === '1') return;
      carousel.dataset.skSwipe = '1';

      var cards = [].slice.call(carousel.querySelectorAll('.sk-reviews__card'));
      if (cards.length < 2) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sk-reviews__swipe';
      btn.setAttribute('aria-label', 'Avis suivant');
      btn.innerHTML =
        '<span class="sk-reviews__swipe-text">Swipe</span>' +
        '<span class="sk-reviews__swipe-arrow" aria-hidden="true">→</span>';

      btn.addEventListener('click', function () {
        var idx = currentIndex(carousel, cards);
        var next = (idx + 1 >= cards.length) ? 0 : idx + 1;
        if (next === 0) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          var delta = cards[next].getBoundingClientRect().left - carousel.getBoundingClientRect().left;
          carousel.scrollBy({ left: delta, behavior: 'smooth' });
        }
      });

      var wrap = carousel.closest('.sk-reviews__carousel-wrap') || carousel;
      wrap.parentNode.insertBefore(btn, wrap.nextSibling);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeButton);
  } else {
    initSwipeButton();
  }
})();
